import React from 'react';
import { useTranslation } from 'react-i18next';
import { appDate } from '@/utils/appDateFormat';
import AppIcon from '../../../../../components/AppIcon';
import type { ComplianceCountry } from '../../../../../models/general';

interface Props {
  serviceYears: number;
  eligibleFrom?: string;
  country: ComplianceCountry;
}

export const EligibilityGate: React.FC<Props> = ({ serviceYears, eligibleFrom, country }) => {
  const { t } = useTranslation('common');

  const minServiceCitation =
    country === 'KSA'
      ? t('Minimum 1 year of service required (Art. 84 KSA Labour Law)')
      : t('Minimum 1 year of service required (Art. 51 UAE Labour Law)');

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-border bg-card py-12 px-6 text-center">
      <AppIcon name="Lock" size={48} className="text-muted-foreground" />
      <div>
        <h3 className="text-lg font-semibold text-foreground">{t('No EOS Entitlement Yet')}</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          {minServiceCitation}
        </p>
      </div>
      <div className="flex gap-6 text-sm">
        <div className="text-center">
          <p className="text-muted-foreground">{t('Service to Date')}</p>
          <p className="font-semibold text-foreground">{serviceYears.toFixed(2)} {t('years')}</p>
        </div>
        {eligibleFrom && (
          <div className="text-center">
            <p className="text-muted-foreground">{t('Eligible From')}</p>
            <p className="font-semibold text-primary">{appDate(eligibleFrom)}</p>
          </div>
        )}
      </div>
    </div>
  );
};
